// 송금확인 모달 컴포넌트
interface TransferConfirmModalProps {
  toName: string | undefined;
  fromName: string | undefined;
  channel: string | null;
  isToMe: boolean | null;
  onConfirm: () => Promise<void>;
  closeModal: () => void;
  isSubmitting: boolean;
}

const TransferConfirmModal: React.FC<TransferConfirmModalProps> = ({
  toName, 
  fromName, 
  channel,
  isToMe, 
  onConfirm, 
  isSubmitting,
}) => {
  const defaultToName = toName || '홍길동';
  const defaultFromName = fromName || '을지문덕';

  // 버튼 텍스트 생성 함수
  const getButtonText = () => {
    if (isSubmitting) {
      return '처리 중...';
    }
    
    if (isToMe === false) {
      return '송금 완료했어요';
    }
    
    return '정산 완료했어요';
  };

  return (
    <div>
      <h2 className="text-[22px] font-bold mb-4">정산 완료하기</h2>
      <div className="text-gray-600 mb-4">
        {
          (()=> {
            switch (isToMe) {
              case true:
                return `${defaultFromName}님으로부터 정산금을 받았나요?`;
              case false:
                return `${defaultToName}님께 ${channel? `${channel} 송금` : '송금'}을 완료했나요?`;
              case null:
                return '두 멤버 사이의 정산이 완료되었나요?'
            }
          })()
        }
        <br/>
        아래 버튼을 누르면 송금기록이 등록돼요!
      </div>
      
      <div className="w-full flex justify-center items-center gap-2">
        <button 
          className='w-full py-3.5 font-bold text-lg rounded-xl bg-gray-50 text-gray-800'
          onClick={onConfirm}
          disabled={isSubmitting}
        >
          {getButtonText()}
        </button>
      </div>
    </div>
  );
};

export default TransferConfirmModal;